import { Pipe, PipeTransform } from '@angular/core';
import { LANGUAGE_LEVEL } from '@app/config/language';

@Pipe({
  name: 'languageLevelNameSlider'
})
export class LanguageLevelNameSliderPipe implements PipeTransform {

  transform(value: number): string {

    const element = LANGUAGE_LEVEL.find(e => +e.id === +value);

    const max = LANGUAGE_LEVEL.map(r => +r.id).reduce((a, b) => Math.max(a, b));

    if (element === undefined)
      return '';

    return `${element.name}${max === +element.id ? '' : ' o mayor'}`;
  }
}
